import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const SubDepManagerManagerToolsNewRequestsCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لديك طلب جديد فى قسمك الفرعى`
          : 'You have new request for your subdepartment'
      }
    />
  )
}

export default SubDepManagerManagerToolsNewRequestsCover
